import { LicensedPartners as LicensedPartnersContent } from '#src/LicensedPartners/index.tsx';

const LicensedPartersBySportTab = () => {
  return <LicensedPartnersContent />;
};

export default LicensedPartersBySportTab;
